import { TableCell, TableRow, Tooltip } from '@mui/material';
import { FC, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MarketCatalogue } from '../../../app/services/api/orderManagementClient';
import { UserContext } from '../../../components/shared/useUser';

type Props = {
  catalogue: MarketCatalogue;
};

const CatalogueItemRow: FC<Props> = ({ catalogue }) => {
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);
  const [searchParams] = useSearchParams();
  
  const canEdit = hasPermissionTo(['ConfigurationAdmin']) || hasPermissionTo(['CatalogueUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    const params = new URLSearchParams();
    const companyId = searchParams.get('companyId');
    const customerTypeId = searchParams.get('customerTypeId');
    const searchTerm = searchParams.get('searchTerm');

    if (companyId) params.set('companyId', companyId);
    if (customerTypeId) params.set('customerTypeId', customerTypeId);
    if (searchTerm) params.set('searchTerm', searchTerm);

    navigate(`/catalogues/edit/${catalogue.customerGroupId}${params.toString() ? `?${params.toString()}` : ''}`);
  };

  const truncateText = (text: string, maxLength: number = 30) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <TableRow
      onClick={canEdit ? handleRowClick : undefined}
      sx={{
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        <Tooltip 
          title={catalogue.name} 
          placement="top"
        >
          <span>{truncateText(catalogue.name)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={catalogue.instanceName} 
          placement="top"
        >
          <span>{truncateText(catalogue.instanceName)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip 
          title={catalogue.marketName} 
          placement="top"
        >
          <span>{truncateText(catalogue.marketName)}</span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default CatalogueItemRow;
